module.exports = __webpack_public_path__ + "img/blue.6fc436c1.png";